import React, { PureComponent } from 'react';
import { withFormik } from 'formik/dist/index';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { sprintf } from 'sprintf-js';

import {
  FILTERS_LABEL_KEY,
  FITLER_VALUE_KEY
} from 'common/constants/SiteConstants';
import Icon from 'common/components/styleguide/Icon';
import Checkbox from 'common/components/styleguide/form/Checkbox';
import List from 'common/components/styleguide/List';
import formikWithAutoSubmit from 'common/hoc/formikWithAutoSubmit';

import { capfl, normalizeString, setFormikMultipleValues } from 'common/utils';

import SS from 'common/components/category/filters/_style';

class FilterSingleForm extends PureComponent {
  state = { showAll: false, isHidden: true };
  toggleShowAll = e => {
    e.preventDefault();
    const { showAll } = this.state;
    this.setState({ showAll: !showAll });
  };
  toggleIsHidden = e => {
    e.preventDefault();
    const { isHidden } = this.state;
    this.setState({ isHidden: !isHidden });
  };
  componentDidMount() {
    const { addFilterResolve } = this.props;
    if (addFilterResolve) {
      addFilterResolve();
    }
  }
  onChange = filterName => e => {
    const { setFieldTouched, setFieldValue, values } = this.props;
    setFormikMultipleValues(e.target, values, setFieldValue);
    setFieldTouched(filterName);
  };
  onBlur = filterName => () => {
    const { setFieldTouched } = this.props;
    setFieldTouched(filterName);
  };
  render() {
    const { t, filterTitle, filterName, data, handleSubmit, hideParamsWithSingleValue = false } = this.props;
    const { showAll, isHidden } = this.state;
    const showText = showAll ? capfl(t('show less')) : capfl(t('show more'));
    if (!_.isEmpty(data) && (!hideParamsWithSingleValue || (hideParamsWithSingleValue && data.length < 2))) {
      let items = [];
      if (showAll) {
        items = data;
      } else {
        items = _.slice(data, 0, 5);
      }
      return (
        <SS.FilterSection>
          <SS.FilterTitle onClick={this.toggleIsHidden}>
            {capfl(t(filterTitle))}
            <SS.TitleIcon>
              {isHidden ? (
                <Icon className="nc-ic_keyboard_arrow_down_48px" />
              ) : (
                <Icon className="nc-ic_keyboard_arrow_up_48px" />
              )}
            </SS.TitleIcon>
          </SS.FilterTitle>
          <SS.FormWrapper isHidden={isHidden}>
            <form onSubmit={handleSubmit}>
              <List reset>
                {_.map(items, (item, index) => {
                  const filterLabel = item[FILTERS_LABEL_KEY];
                  const filterValue = item[FITLER_VALUE_KEY];
                  const filterSelected = item.selected;
                  const id = sprintf(
                    '%1$s-%2$s-%3$s',
                    filterName,
                    normalizeString(filterValue, '-', false),
                    index
                  );
                  const filterWrapperKey = sprintf('%1$s-wrapper-%2$s', id, index);
                  const filterKey = sprintf('%1$s-%2$s', id, index);
                  return (
                    <SS.ListItem key={filterWrapperKey}>
                      <Checkbox
                        id={id}
                        key={filterKey}
                        label={<SS.LabelText>{filterLabel}</SS.LabelText>}
                        name={filterName}
                        value={filterValue}
                        setValueChecked={filterSelected}
                        onChange={this.onChange(filterName)}
                        onBlur={this.onBlur(filterName)}
                      />
                      <SS.ProductCount>{item.productCount}</SS.ProductCount>
                    </SS.ListItem>
                  );
                })}
              </List>
            </form>
            {data.length > 5 ? (
              <SS.ShowMore href="#" onClick={this.toggleShowAll}>
                {showText}
              </SS.ShowMore>
            ) : (
              ''
            )}
          </SS.FormWrapper>
        </SS.FilterSection>
      );
    }
    return null;
  }
}

const formikEnhancer = withFormik({
  enableReinitialize: true,
  mapPropsToValues: props => {
    const { activeFilters } = props;
    const filterValues = _.get(activeFilters, [props.filterName], null);
    return { [props.filterName]: filterValues };
  },
  handleSubmit: (values, { props, setSubmitting }) => {
    const { submitFilters } = props;
    if (submitFilters) {
      submitFilters(values);
    }
    setSubmitting(false);
  }
});

const EnhancedFilterSingleForm = formikEnhancer(
  formikWithAutoSubmit(FilterSingleForm)
);

export default withTranslation()(EnhancedFilterSingleForm);
